import { useRef, useEffect } from 'react';

const useAnimationFrame = (callback, isStop) => {
  const requestRef = useRef(0);
  const previousTimeRef = useRef();

  useEffect(() => {
    if (isStop) {
      return () => {};
    }
    const animate = (time) => {
      if (previousTimeRef.current !== undefined) {
        const deltaTime = time - previousTimeRef.current;
        callback(deltaTime);
      }
      previousTimeRef.current = time;
      requestRef.current = requestAnimationFrame(animate);
    };
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [isStop]); // Make sure the effect runs only once
};

export default useAnimationFrame;
